import { VOUCHERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import vouchersTypes from '../../constants/vouchersTypes'
import { axios } from '../../services'

//
const get_voucher_request = () => {
  return {
    type: vouchersTypes.get.request
  }
}

const get_voucher_success = (response) => {
  return {
    type: vouchersTypes.get.success,
    payload: response.data.voucher
  }
}

const get_voucher_failure = (messages) => {
  return {
    type: vouchersTypes.get.failure,
    payload: messages
  }
}

const get_voucher = (voucher_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(get_voucher_request())

    // Request
    axios.get(
      formatRoute(VOUCHERS_ROUTES.get, {id: voucher_id})
    ).then( response => {
      // success
      dispatch( get_voucher_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching voucher."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( get_voucher_failure(errors))
    })
  }

}

export {
  get_voucher
}



// WEBPACK FOOTER //
// ./src/js/actions/vouchers/get.js